import React__default from 'react';
import { Text } from '@grandvisionhq/elements';
import { useLink } from '@grandvisionhq/frk-routing';
import { useIntl } from '@grandvisionhq/state';
import OrderListItem from './OrderListItem.js';
import { logOrderEvent } from '../../../data-layer/orders.js';
import { makeOrderDetailsClickEvent } from '../../../data-layer/utils.js';

const OrderListItemContainer = ({ lineItems , orderDate , orderNumber , paymentStatus ,  })=>{
    const { dateTime , getLabel  } = useIntl();
    var ref;
    const { href , onClick  } = (ref = useLink({
        route: 'me.orders.detail',
        params: {
            orderId: orderNumber
        }
    })) !== null && ref !== void 0 ? ref : {};
    const labels = {
        order: getLabel('common.order'),
        viewDetails: getLabel('account.common.viewDetails')
    };
    const handleOnClick = (e)=>{
        logOrderEvent(makeOrderDetailsClickEvent('my_online_orders', orderNumber, paymentStatus));
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    };
    return /*#__PURE__*/ React__default.createElement("div", {
        className: "order-list-item",
        key: orderNumber
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "order-list-item__header"
    }, /*#__PURE__*/ React__default.createElement(Text, {
        variant: "body-head"
    }, labels.order, " ", orderNumber), /*#__PURE__*/ React__default.createElement(Text, {
        variant: "list",
        color: "text-secondary"
    }, dateTime.formatShortDate(orderDate))), lineItems.map((lineItem)=>/*#__PURE__*/ React__default.createElement(OrderListItem, {
            key: `${lineItem.title}-${lineItem.subtitle}`,
            header: lineItem.title,
            subtitle: lineItem.subtitle,
            imageUrl: lineItem.productImage,
            href: href,
            onClick: handleOnClick,
            labels: labels
        })
    ));
};
var OrderListItemContainer$1 = OrderListItemContainer;

export { OrderListItemContainer$1 as default };
//# sourceMappingURL=OrderListItemContainer.js.map
